import React from 'react'

import Button from 'components/Button'
import SimpleTable from 'components/Tables/SimpleTable'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import { IPhoneSystemFormData } from '../PhoneSystemForm.container'
import Overlay from 'components/Overlay'

export interface ISummaryStepProps {
  prev: Function
  formData: IPhoneSystemFormData
  submitting: boolean
  setHeadings?: Function
}

export const SummaryStep = (props: ISummaryStepProps) => {
  const { prev, formData, submitting, setHeadings } = props
  const plan = formData.plan!

  setHeadings &&
    setHeadings({
      heading: "And we're done. Great Huh!",
      subHeading: 'Take your calls here, there or just about anywhere.',
    })

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Now you’re ready to take on the world with your new All In One PBX Phone System from
          Pickle. Review your summary below and If everything looks good, click 'finish' and we'll
          put Pickle to work in your business! You'll be able to monitor the status of your order in
          the dashboard on your Pickle Portal.
        </div>

        <SimpleTable>
          <div>
            <div>Plan:</div>
            <div>{plan.name}</div>
          </div>
          <div>
            <div>Plan Cost:</div>
            <div>${plan.monthlyCharge}/mth (ex GST)</div>
          </div>
          <div>
            <div>Simultaneous Calls:</div>
            <div>Up to {plan.simultaneousCallsLimit}</div>
          </div>
          <div>
            <div>Extensions:</div>
            <div>Up to {plan.maxExtensions}</div>
          </div>
          <div>
            <div>Hunt Groups:</div>
            <div>Up to {plan.maxHuntGroups}</div>
          </div>
          <div style={{ alignItems: 'start' }}>
            <div>DID Numbers:</div>
            <div>
              {formData.didNumbers?.map(number => (
                <div key={number.id} className={sMarg.mb5}>
                  {number.number} {number.city ? `(${number.city})` : null}
                </div>
              ))}
            </div>
          </div>
        </SimpleTable>

        <div className={cn(sText.descrip5, sMarg.mt30)}>
          <p>
            I wish to apply for the Phone System Service described in this application form and
            acknowledge that if my application is accepted it will be provided on the terms and
            conditions set out in this application form and Our Customer Terms. If there is an
            inconsistency between this application form and Our Customer Terms, this application
            form applies instead of Our Customer Terms to the extent of that inconsistency.
          </p>
          <p>
            I acknowledge that I have had the opportunity to review the{' '}
            <a href="https://thinkpickle.com.au/terms" target="_blank">
              Terms and Conditions.
            </a>
          </p>
          <p>
            You agree and will ensure that any of your related bodies corporate which receive
            services connected with this application form and your representatives are aware, that
            Pickle may:
          </p>
          <p>
            (a) use and disclose information about you and each of them in accordance with Pickle’s
            Privacy Statement; and
          </p>
          <p>
            (b) give to, seek and obtain from, a credit reporting agency, information (including
            personal and credit information) about you to assess your creditworthiness.
          </p>
        </div>

        {submitting && (
          <Overlay>
            Creating your phone system... This can take a minute or two. You can always send our
            friendly support a message if you have any issues.
          </Overlay>
        )}
      </div>
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button color="tertiary" type="submit" loading={submitting} disabled={submitting}>
          I Agree
        </Button>
        <br />
        <br />
        <Button plain onClick={prev}>
          Back
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemForm/SummaryStep/SummaryStep.tsx